import React from "react";

const StyledCtaText = ({ children, fontColor }) => {
  return (
    <p className={`text-lg font-bold font-cp-bold ${fontColor}`}>{children}</p>
  );
};

export default StyledCtaText;
